module.exports = __webpack_public_path__ + "img/kzjlflsf.b8c9bf37.png";